import { createReducer } from '@reduxjs/toolkit';

import {
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  VERIFY_INVITE_TOKEN,
  VERIFY_INVITE_TOKEN_SUCCESS,
  VERIFY_INVITE_TOKEN_FAILURE,
  RESEND_OTP_REQUEST,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  RESET_INVITE_REQUEST,
} from '@store/inviteUser/signUp/signUp.const';

export const initialState = {
  meta: {
    hasError: false,
    isLoading: false,
    isResendingOtp: false,
    errorMessage: '',
  },
  model: {
    user: {},
    password: '',
    userToken: '',
  },
};

const signUpReducer = createReducer(initialState, builder => {
  builder
    .addCase(SIGNUP_REQUEST, (state, action) => {
      state.model.password = action?.payload?.user?.password;
      state.model.userToken = action?.payload?.user?.token;
    })
    .addCase(SIGNUP_SUCCESS, (state, action) => {
      state.model.user = action?.payload?.user;
    })
    .addCase(SIGNUP_FAILURE, (state, action) => {
      state.model.user = action?.payload?.user;
    })
    .addCase(VERIFY_INVITE_TOKEN, state => {
      state.meta.isLoading = true;
      state.meta.hasError = false;
      state.model.user = {};
    })
    .addCase(VERIFY_INVITE_TOKEN_SUCCESS, (state, action) => {
      state.meta.isLoading = false;
      state.meta.hasError = false;
      state.model.user = action?.payload?.user;
      state.model.token = action?.payload?.token;
    })
    .addCase(VERIFY_INVITE_TOKEN_FAILURE, (state, action) => {
      state.meta.isLoading = false;
      state.meta.hasError = true;
      state.meta.errorMessage = action?.payload;
    })
    .addCase(RESEND_OTP_REQUEST, state => {
      state.meta.isResendingOtp = true;
    })
    .addCase(RESEND_OTP_SUCCESS, state => {
      state.meta.isResendingOtp = false;
    })
    .addCase(RESEND_OTP_FAILURE, state => {
      state.meta.isResendingOtp = false;
    })
    .addCase(RESET_INVITE_REQUEST, () => initialState)
    .addDefaultCase(() => {});
});

export default signUpReducer;
